import * as get from 'lodash/get';

import { StoreColumnExtractor } from './store-column-extractor';

export class StoreLodashExtractor implements StoreColumnExtractor {
	constructor(
		public readonly storeConfig: any[],
		public readonly expression: string,
		public readonly defaultValue?: number | string,
		public readonly suffix?: number | string
	) { }

	public storeConfigDependencies(): any[] {
		return this.storeConfig;
	}
	public extractor(): (storeData: any) => any {
		if (this.suffix) {
			return (storeData: any) => get(storeData, this.expression + this.suffix, this.defaultValue);
		}
		return (storeData: any) => get(storeData, this.expression, this.defaultValue);
	}

	public getDataPointPath(): string {
		const dataPath = this.storeConfig.length > 0 ? this.storeConfig[0] + ' ' + this.expression : this.expression;
		return dataPath;
	}
}
